<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="6">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.production_order_package_header_tips') ||
                  '包装编号/包装名称/包装规格 ....'
              "
            />
            <b-input-group-append>
              <b-button-group slot="reference">
                <b-button
                  variant="link"
                  size="sm"
                  class="search-dropdown-button"
                  squared
                  @click="openAdvqueryDialog"
                >
                  {{ $l('INDEX.advanced_search') || '高级搜索' }}
                </b-button>
                <b-button variant="primary" size="sm" @click="query">
                  <i class="fa fa-search" />
                </b-button>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
    >
      <el-form
        ref="form"
        :model="form"
        label-width="135px"
        size="small"
        label-position="right"
      >
        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_package_packageType') || '包装类型'"
            >
              <dict-select
                v-model="form.listPackageType"
                url="/master/common/dict/biz"
                :body="{ dictType: 'packageType' }"
                :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
                size="small"
                multiple
                filterable
                clearable
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_package_materialNo') || '包装编号'"
            >
              <el-input v-model.trim="form.materialNo" clearable> </el-input>
            </el-form-item>
          </el-col>
        </el-row>

        <el-row :gutter="10">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_package_materialName') || '包装名称'"
            >
              <el-input v-model.trim="form.materialName" clearable> </el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.order_package_materialSpec') || '箱规格'"
            >
              <el-input v-model.trim="form.materialSpec" clearable> </el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="10">
          <el-form-item
            :label="
              $l('INDEX.table_label_production_order_scm_name') || '供应商'
            "
          >
            <dict-select
              v-model="form.listScmCode"
              url="/master/common/dict/scmCooperated"
              :placeholder="$l('INDEX.tips_select_data') || '请选择...'"
              size="small"
              multiple
              filterable
              clearable
            ></dict-select>
          </el-form-item>
        </el-row>
        <el-row>
          <el-form-item
            :label="$l('INDEX.form_label_modification_time') || '修改时间'"
          >
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyTimeStart"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="modifyTimeStartPicker"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
            <el-col class="line" :span="2">-</el-col>
            <el-col :span="11">
              <el-date-picker
                v-model="form.modifyTimeEnd"
                type="date"
                value-format="yyyy-MM-dd"
                :picker-options="modifyTimeEndPicker"
                :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                style="width: 100%"
              >
              </el-date-picker>
            </el-col>
          </el-form-item>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
// 初始表单
const initForm = { keyword: '' }
export default {
  data() {
    return {
      form: { ...initForm },
      advqueryDialogVisible: false,
      modifyTimeStartPicker: this.dateModityEnd(),
      modifyTimeEndPicker: this.dateModityStart(),
    }
  },
  mounted() {
    this.query()
  },
  methods: {
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    reset() {
      this.form = { ...initForm }
    },
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
    query() {
      this.$emit('query', this.form)
    },
    dateModityEnd() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeEnd) {
            return new Date(self.form.modifyTimeEnd).getTime() < time.getTime()
          }
        },
      }
    },
    dateModityStart() {
      const self = this
      return {
        disabledDate(time) {
          if (self.form.modifyTimeStart) {
            return (
              new Date(self.form.modifyTimeStart).getTime() - 3600 * 1000 * 24 >
              time.getTime()
            )
          }
        },
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
